import { useState } from 'react';
import { ShieldAlert, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { stopImpersonation as stopImpersonationApi } from '@/api/users';
import { IMPERSONATION_EXIT_PATH } from '@/lib/constants';
import { vibrateTap } from '@/lib/utils/haptics';
import { t } from '@/lib/i18n';
import { resetIdentityCaches } from '@/lib/session/identityCache';

/**
 * Admin boshqa foydalanuvchi nomidan ishlayotganini BILDIRIB turuvchi panel.
 *
 * Ekranning tepasida doim ko'rinadi va yagona chiqish yo'lini beradi. Usiz
 * admin kimning nomidan ish qilayotganini unutib, noto'g'ri hisobga yozib
 * yuborishi mumkin — shuning uchun panel yopilmaydi.
 */
export function ImpersonationBanner() {
  const impersonation = useAuthStore((s) => s.impersonation);
  const stopImpersonation = useAuthStore((s) => s.stopImpersonation);
  const [leaving, setLeaving] = useState(false);

  if (!impersonation) return null;

  const { targetUser } = impersonation;
  const targetName = `${targetUser.first_name} ${targetUser.last_name}`.trim();

  const handleReturn = async () => {
    vibrateTap();
    setLeaving(true);
    const ended = stopImpersonation();
    try {
      // Audit yozuvi ADMIN tokeni bilan yuboriladi (sessiya allaqachon tiklangan)
      if (ended) await stopImpersonationApi(ended.targetUser.id);
    } catch {
      // Audit yozilmasa ham qaytish amalga oshadi — bu bloklamaydi
    } finally {
      await resetIdentityCaches();
      setLeaving(false);
      // To'liq qayta yuklash: SPA navigatsiyasida joriy sahifaning `RoleRoute`
      // tekshiruvi `/403` ga uloqtirib yuboradi (UsersPage.tsx dagi izohga
      // qarang) va maqsadli foydalanuvchi keshi ekranda qolib ketadi.
      window.location.assign(IMPERSONATION_EXIT_PATH);
    }
  };

  return (
    <div className="safe-top sticky top-0 z-[150] w-full bg-warn text-inverse shadow-card">
      <div className="mx-auto flex max-w-2xl items-center gap-2.5 px-4 py-2">
        <ShieldAlert size={16} className="shrink-0" />
        <p className="min-w-0 flex-1 truncate text-[12px] font-semibold">
          {t('Siz {name} sifatida ishlayapsiz', { name: targetName })}
        </p>
        <button
          type="button"
          onClick={() => void handleReturn()}
          disabled={leaving}
          className="flex shrink-0 items-center gap-1.5 rounded-pill bg-inverse px-3 py-1.5 text-[12px] font-bold text-on-inverse transition-transform active:scale-95 disabled:opacity-60"
        >
          <LogOut size={13} />
          {t('Adminga qaytish')}
        </button>
      </div>
    </div>
  );
}
